<template>
  <div class="page-column">
    <Header />
    <HomeBanner />
    <VideoNum />
    <Organizing />
    <Dataintroduction />
    <Department />
    <TeamPlayer />
    <DataInternet />
    <!-- <div style="background-color: #f4f4f4;text-align: center;width: 1200px;margin: 0 auto;">
      <img style="width:50%;float: left;height:150px;" src="https://static.daoba.com/880186366461.jpg"/>
      <img style="width:50%;float: left;height:150px;" src="https://static.daoba.com//861924122607.png"/>
    </div> -->
    <div style="background-color: #f4f4f4;text-align: center;">
      <img style="width:1200px;" src="https://static.daoba.com/880186366461.jpg"/>
    </div>
    <HomeFooter />
    <BackTop />
  </div>
</template>

<script>
import Header from '../layout/Header.vue'
import HomeBanner from '../layout/HomeBanner.vue'
import VideoNum from './components/VideoNum.vue'
import Organizing from './components/Organizing.vue'
import Dataintroduction from './components/Dataintroduction.vue'
import Department from './components/Department.vue'
import TeamPlayer from './components/TeamPlayer.vue'
import DataInternet from './components/DataInternet.vue'
import HomeFooter from '../layout/HomeFooter.vue'
import BackTop from '@comm/components/public/BackTop'
export default {
  components: {
    Header,
    HomeBanner,
    HomeFooter,
    VideoNum,
    Organizing,
    Dataintroduction,
    Department,
    TeamPlayer,
    DataInternet,
    BackTop,
  },
  created () {
    document.title = '道吧网 | 赛事服务一站式平台'
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动事件
  },
  methods: {
    handleScroll () {
      // 变量t是滚动条滚动时，距离顶部的距离
      var t = document.documentElement.scrollTop || document.body.scrollTop
      if (t > 400) {
        document.getElementById('look').className = 'look-btn on'
        document.getElementById('txt-b').className = 'txt-box txton'
        if (t > 700) {
          document.getElementById('data-on').className = 'data-box data-on-box'
        }
        if (t > 1200) {
          document.getElementById('part-on').className = 'part-img part-on-box'
        }
        if (t > 1900) {
          document.getElementById('player-on').className = 'player-img player-on-box'
        }
      } else if (t < 200) {
        document.getElementById('look').className = 'look-btn'
        document.getElementById('txt-b').className = 'txt-box'
        document.getElementById('data-on').className = 'data-box'
        document.getElementById('part-on').className = 'part-img'
        document.getElementById('player-on').className = 'player-img'
      }
    },
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll) // 监听页面滚动事件
  },
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/Home.vue